<template>
    <div class="kinship-wrapper">
        <div v-if="isShowTitle" class="mb20 fb">{{title}}</div>
        <avue-crud class="upload-wrapper" :data="data" :option="option" v-model="form" :table-loading="loading" ref="crud" @row-del="rowDel" :before-open="beforeOpenHandle" @row-update="rowUpdate" @row-save="rowSave" @error="error">
            <!-- <template slot="fileUrlType" slot-scope="{file}">
                <span>{{file}}</span>
            </template> -->
            <template slot="imgListForm" slot-scope="{row,column,label,dic,index,disabled,readonly,size}">
                <div v-for="(item,n) in form.orderSpecificImageList" :key="n">
                    <avue-form :option="uploadOption" v-model="form.orderSpecificImageList[n]" ref="uploadForm"></avue-form>
                </div>
            </template>
            <template slot-scope="{row}" slot="orderInitId">
                <div class="num-family">{{row.orderInitId}}</div>
            </template>
            <template slot-scope="{row}" slot="id">
                <div class="num-family">{{row.id}}</div>
            </template>
            <template slot-scope="scope" slot="menu" v-if="isAdd||isSee">
                <el-button type="text" size="mini" v-if="isAdd" @click="addOrderInitImplemen(scope.row)">添加具体执行</el-button>
                <el-button type="text" size="mini" v-if="isSee" @click="seeDetailHandle(scope.row)">查看</el-button>
            </template>
        </avue-crud>
        <div class="tac mt15" slot>
            <el-button type="primary" size="mini" icon="el-icon-plus" v-if="isShowBtn" @click="$refs.crud.rowAdd()">{{addBtnTitle}}</el-button>
            <slot></slot>
        </div>
        <el-dialog append-to-body width="80%" :visible.sync="OnlinelVisible" custom-class="common-dialog">
            <pdfOnLine :src="pdfSrc"></pdfOnLine>
        </el-dialog>
    </div>
</template>
<script>
import { addOrderInitPlan, updateOrderInitPlan, removeOrderInitPlan, getOrderInitPlanList } from "@/api/order/orderinit";
import { mapGetters } from "vuex";
import { getAttachFile } from "@/api/resource/oss"
import { getDictTree } from "@/api/system/dictbiz"
import { emptySurplus } from "@/util/util"
import pdfOnLine from '@/components/pdf-online/index.vue'
// import implement from '@/components/orderinit/implement.vue'
export default {
    props: {
        isShowTitle: {
            type: Boolean,
            default: true,
        },
        title: {
            type: String,
            default: '具体计划单'
        },
        isShowBtn: {
            type: Boolean,
            default: true
        },
        addBtnTitle: {
            type: String,
            default: '添加具体计划'
        },
        orderInitId: {
            type: String,
            default: ''
        },
        list: {
            type: Array,
            default: () => []
        },
        isOpt: {
            type: Boolean,
            default: true
        },
        isAdd: {
            type: Boolean,
            default: false
        },
        date: {
            type: String,
            default: ''
        },
        initPlanList: {
            type: Array,
            default: () => []
        },
        isSee: {
            type: Boolean,
            default: false
        }
    },
    components: {
        pdfOnLine
    },
    data() {
        return {
            pdfSrc: '',
            OnlinelVisible: false,
            txtList: [],
            addIsShow: false,
            seeIsShow: false,
            form: {},
            loading: false,
            page: {
                pageSize: 10,
                currentPage: 1,
                total: 0
            },
            data: [],
            uploadOption: {
                size: 'mini',
                emptyBtn: false,
                submitBtn: false,
                column: [{
                        labelWidth: 0,
                        prop: "imageUrl",
                        type: 'upload',
                        dataType: 'string',
                        listType: 'picture-card',
                        loadText: '图片上传中，请稍等',
                        tip: '只能上传jpg/png凭证图片，且不超过2MB',
                        action: '/api/blade-resource/oss/endpoint/put-file-attach',
                        propsHttp: {
                            res: 'data',
                            url: 'link'
                        },
                        // canvasOption: {
                        //     text: '公益项目信息化管理系统',
                        //     ratio: 0.1
                        // },
                        data: {
                            fileName: 'fileUrl'
                        },
                        span: 24,
                        uploadAfter: (res, done, loading, column) => {
                            let len = this.form.orderSpecificImageList.length
                            done()
                            this.$nextTick(() => {
                                console.log(this.form.orderSpecificImageList[len - 1].imageUrl)
                                if (this.form.orderSpecificImageList[len - 1].imageUrl) {
                                    this.form.orderSpecificImageList.push({ imageUrl: '', note: '' })
                                }
                            })
                          

                        },
                        uploadBefore: (file, done, loading) => {
                            var FileExt = file.name.replace(/.+\./, "");
                            if (['jpg', 'png', 'jpeg'].indexOf(FileExt.toLowerCase()) === -1) {
                                this.$message({
                                    type: 'warning',
                                    message: '请上传后缀名为jpg/png的图片！'
                                });
                                loading();
                            } else {
                                this.isLt2k = file.size / (1024 * 1024) < 2;
                                if (!this.isLt2k) {
                                    this.$message({
                                        message: '上传图片大小不能超过2MB!',
                                        type: 'error'
                                    });
                                    loading();
                                } else {
                                    done()
                                }
                            }
                        },
                        uploadDelete: (file, column) => {
                            let n = this.form.orderSpecificImageList.findIndex(v => v.imageUrl == file)
                            this.form.orderSpecificImageList.splice(n, 1);
                        }
                    },
                    {
                        labelWidth: 0,
                        prop: 'note',
                        type: 'textarea',
                        span: 24,
                        placeholder: '请填写说明'
                    }
                ]
            },
            option: {
                size: 'mini',
                border: true,
                align: 'center',
                menuAlign: 'center',
                delBtn: !this.isAdd || !this.isSee,
                viewBtn: !this.isAdd || !this.isSee,
                editBtn: !this.isAdd || !this.isSee,
                addBtn: false,
                cellBtn: false,
                columnBtn: false,
                refreshBtn: false,
                menuBtn: false,
                labelWidth: 120,
                menu: this.isOpt || this.isAdd || this.isSee,
                index: true,
                column: [{
                        label: "计划类型",
                        prop: "type",
                        type: "select",
                        dataType: 'string',
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        // showAllLevels: false,
                        // dataType: 'string',
                        // emitPath: false,
                        dicQuery: {
                            code: "work_type"
                        },
                        // props: {
                        //     label: "title",
                        //     value: "value"
                        // },
                        disabled: true,
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                        formatter: (row, value, label, column) => {
                            return label
                        },
                        span: 24,
                    }, {
                        label: '初始计划单序号',
                        prop: 'orderInitNumber',
                        // hide: true,
                        span: 24,
                        disabled: true
                    }, {
                        label: '具体计划单编号',
                        prop: 'specificNu',
                        row: true,
                        // hide: true,
                        disabled: true,
                        span: 24,
                        placeholder: '计划单编号自动生成'
                    },
                    {
                        label: '具体计划单序号',
                        prop: 'specificNo',
                        row: true,
                        // hide: true,
                        disabled: true,
                        span: 24,
                        placeholder: '计划单编号自动生成'
                    },
                    {
                        label: '具体内容',
                        prop: 'content',
                        row: true,
                        type: 'textarea',
                        span: 24,
                        rules: [{
                            required: true,
                            trigger: "blur",
                            message: "请输入内容",
                        }]
                    },
                    // {
                    //     label: '图片',
                    //     prop: 'img',
                    //     dataType: 'string',
                    //     type: 'img',
                    //     display: false,
                    //     hide: this.isAdd,
                    // },
                    {
                        label: "机构",
                        prop: "specificCreateDeptName",
                        disabled: true,
                        display: false,
                        span: 24,
                    },
                    {
                        label: "执行人",
                        prop: 'performName',
                        span: 24,
                        row: true,
                        rules: [{
                            required: true,
                            trigger: "blur",
                            message: "请输入执行人",
                        }]
                    },
                    {
                        label: '开始时间',
                        prop: 'beginTime',
                        row: true,
                        type: 'date',
                        valueFormat: "yyyy-MM-dd hh:mm:ss",
                        span: 24,
                        rules: [{
                            required: true,
                            message: "请选择时间",
                            trigger: "change",
                        }]
                    },
                    {
                        label: '完成时间',
                        prop: 'endTime',
                        type: 'date',
                        valueFormat: "yyyy-MM-dd hh:mm:ss",
                        span: 24,
                        rules: [{
                            required: true,
                            message: "请选择时间",
                            trigger: "change",
                        }]
                    },
                    {
                        label: "上传pdf",
                        prop: "pdfUrls",
                        type: 'upload',
                        dataType: 'array',
                        loadText: '文件上传中，请稍等',
                        tip: '只能上传pdf凭证文件，且不超过2MB',
                        // action: '/api/blade-resource/oss/endpoint/put-file-attach-by-name-new',
                        // propsHttp: {
                        //     url: 'data',
                        // },
                        action: '/api/blade-resource/oss/endpoint/put-file',
                        propsHttp: {
                            res: 'data',
                            url: 'link',
                        },
                        data: {
                            fileName: 'pdfUrls'
                        },
                        uploadBefore: (file, done, loading) => {
                            var FileExt = file.name.replace(/.+\./, "");
                            if (['pdf'].indexOf(FileExt.toLowerCase()) === -1) {
                                this.$message({
                                    type: 'warning',
                                    message: '请上传后缀名为pdf的附件！'
                                });
                                loading();
                            } else {
                                this.isLt2k = file.size / (1024 * 1024) < 2;
                                if (!this.isLt2k) {
                                    this.$message({
                                        message: '上传文件大小不能超过2MB!',
                                        type: 'error'
                                    });
                                    loading();
                                } else {
                                    done()
                                }
                            }
                        },
                        uploadPreview: (file, column, done) => {
                            this.pdfSrc = file.url
                            this.OnlinelVisible = true
                        },
                        display: this.isAdd,
                        span: 24,
                        hide: true,
                    },
                    {
                        label: "上传图片",
                        prop: "imgList",
                        display: this.isAdd,
                        hide: true,
                        span: 24,
                        row: true,
                        slot: true,
                    }
                ]
            }
        }
    },
    watch: {
        initOrderId() {
            this.form.orderInitId = this.orderInitId
        },
        list: {
            deep: true,
            handler(val) {
                this.data = this.list
            }
        },
        isAdd() {
            this.init()
        },
        isSee() {
            this.init()
        },
        date() {
            this.init()
            this.refreshChange()
        }
    },
    methods: {
        init() {
            this.addIsShow = this.isAdd
            this.seeIsShow = this.isSee
            this.option.delBtn = !this.addIsShow && !this.seeIsShow;
            this.option.viewBtn = !this.addIsShow && !this.seeIsShow;
            this.option.editBtn = !this.addIsShow && !this.seeIsShow;
            this.option.menu = this.isOpt || this.addIsShow || this.seeIsShow
            let column = this.findObject(this.option.column, 'pdfUrls')
            column.display = this.addIsShow || this.seeIsShow
            let column1 = this.findObject(this.option.column, 'imgList')
            column1.display = this.addIsShow || this.seeIsShow
            // let column2 = this.findObject(this.option.column, 'img')
            // column2.hide = !this.addIsShow
        },
        addOrderInitImplemen(row) {
            let list = []
            if (row.orderSpecificImageList.length == 0) {
                row.orderSpecificImageList.push({ imageUrl: '', note: '' })
            } else {
                let j = 0;
                for (let i = 0; i < row.orderSpecificImageList.length; i++) {
                    j++
                    if (!row.orderSpecificImageList[i].imageUrl && !row.orderSpecificImageList[i].note) {
                        j--;
                    }
                }
                if (j == row.orderSpecificImageList.length) {
                    row.orderSpecificImageList.push({ imageUrl: '', note: '' })
                }
            }
            this.form = row
            this.$refs.crud.rowEdit(row)
        },
        rowSave(row, done, loading) {
            row.orderInitialPlanId = this.orderInitId
            addOrderInitPlan(row).then(res => {
                this.$message({
                    type: "success",
                    message: "操作成功!"
                });
                this.data.push(res.data.data)
                this.$emit('getList', this.data)
				this.$emit('returnInfo',this.data)
                done();
            }, error => {
                window.console.log(error);
                loading();
            });
        },
        rowUpdate(row, index, done, loading) {
            row.orderSpecificImageList.splice(row.orderSpecificImageList.length - 1, 1)
            row.orderInitialPlanId = this.orderInitId
            updateOrderInitPlan(row).then(res => {
                this.$message({
                    type: "success",
                    message: "操作成功!"
                });
                // let arr = []
                // res.data.data.orderSpecificImageList.map(m => {
                //     arr.push(m.imageUrl)
                // })
                // res.data.data.img = arr.join(",")
                // console.log(res.data.data);
                res.data.data.specificNu = row.specificNu
                res.data.data.specificNo = row.specificNo
                this.$set(this.data, index, res.data.data)
                this.$emit('getList', this.data)
                done(res.data.data);
            }, error => {
                window.console.log(error);
                loading();
            });
        },
        rowDel(row, index) {
            this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                .then(() => {
                    return removeOrderInitPlan(row.id);
                })
                .then(() => {
                    this.data.splice(index, 1)
                    this.$emit('getList', this.data)
					this.$emit('returnInfo',this.data)
                    this.$message({
                        type: "success",
                        message: "操作成功!"
                    });
                });
        },
        beforeOpenHandle(done, type) {
            if (type == 'add') {
                setTimeout(() => {
                    this.form.orderInitNumber = this.initPlanList[0].orderInitNumber
                    this.form.type = this.initPlanList[0].type
                }, 300)
            }
            done()
        },
        // 刷新事件
        refreshChange() {
            this.onLoad(this.page);
        },
        onLoad(page, params = {}) {
            if (this.loading) {
                return;
            }
            this.loading = true;
            this.data = []
            if (this.orderInitId) {
                getOrderInitPlanList(this.orderInitId).then(res => {
                    // res.data.data.map(v => {
                    //     let arr = []
                    //     v.orderSpecificImageList.map(m => {
                    //         arr.push(m.imageUrl)
                    //     })
                    //     v.img = arr.join(",")
                    // })
                    this.data = res.data.data;
                    // this.data.img = res
                    this.$emit('getList', this.data)
                    this.loading = false;
                });
            } else {
                let p = []
                this.list.map(v => {
                    p = p.concat(v.orderSpecificList)
                })
                // p.map(v => {
                //     let arr = []
                //     v.orderSpecificImageList.map(m => {
                //         arr.push(m.imageUrl)
                //     })
                //     v.img = arr.join(",")
                // })
                this.data = p
                this.loading = false;
                // let p = []
                // this.list.map(v => {
                //     p.push(getOrderInitPlanList(v.id))
                // })
                // const ajax = Promise.all(p);
                // ajax.then(res => {
                //     res.map(v => {
                //         this.data = this.data.concat(v.data.data)
                //     })
                //     this.loading = false;
                // }).catch(() => {
                //     this.loading = false;
                // })
            }
        },
        seeDetailHandle(row) {
            this.$refs.crud.rowView(row)
        },
        error(err) {
            this.$message.success('请填写完整信息');
        }
    }
}

</script>
<style lang="scss">
.kinship-wrapper .avue-crud__menu {
    display: none !important;
}

</style>
